<header [ngClass]="{ 'header-sticky': isHeaderSticky, 'mat-elevation-z1': isHeaderSticky }" class="header">
	<div fxLayout="row" class="layout-container p-0">
		<div fxLayout="row" class="mobile-menu">
			<a class="logo" href="/">
				<img src="https://img.clearcals.com/site/images/hint/logo_round.svg" alt="Clearcals" />
				<h3 class="heading-3 title-text" [ngClass]="{ 'text-black': currentSection == '/' }">
					Clearcals
				</h3>
			</a>

			<button mat-icon-button id="toggle-menu" (click)="toggleMenu()">
				<ic-icon [icon]="menuIcon"></ic-icon>
			</button>
		</div>

		<div class="menu-sections">
			<ul class="header-content">
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/'" [ngClass]="{ 'text-black': currentSection == '/' }">Home</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
					<a [routerLink]="'/store/garmin-watches'"
						[ngClass]="{ 'text-black': currentSection == '/' }">Store</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/products/hint'" [ngClass]="{ 'text-black': currentSection == '/' }">Hint</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/products/expert'" [ngClass]="{ 'text-black': currentSection == '/' }">Expert</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/resources'" [ngClass]="{ 'text-black': currentSection == '/' }">Resources</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/blogs'" [ngClass]="{ 'text-black': currentSection == '/' }">Blogs</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/web-stories'" [ngClass]="{ 'text-black': currentSection == '/' }">Web Stories</a>
				</li>
				<li class="list-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">
					<a [routerLink]="'/contact'" [ngClass]="{ 'text-black': currentSection == '/' }">Contact</a>
				</li>
			</ul>

			<button mat-raised-button color="primary" aria-label="Download"
				(click)="openLink('https://hintclearcals.app.link/NBgy2ToT3wb')">
				Download
			</button>
		</div>
	</div>
</header>